export const GET_DEPOSIT_LIST_START = 'GET_DEPOSIT_LIST_START';
export const GET_DEPOSIT_LIST_SUCCESS = 'GET_DEPOSIT_LIST_SUCCESS';
export const GET_DEPOSIT_LIST_FAILED = 'GET_DEPOSIT_LIST_FAILED';

export const GET_DEPOSIT_BY_ID_START = 'GET_DEPOSIT_BY_ID_START';
export const GET_DEPOSIT_BY_ID_SUCCESS = 'GET_DEPOSIT_BY_ID_SUCCESS';
export const GET_DEPOSIT_BY_ID_FAILED = 'GET_DEPOSIT_BY_ID_FAILED';

export const GET_DEPOSIT_PAYMENT_BY_ID_START = 'GET_DEPOSIT_PAYMENT_BY_ID_START';
export const GET_DEPOSIT_PAYMENT_BY_ID_SUCCESS = 'GET_DEPOSIT_PAYMENT_BY_ID_SUCCESS';
export const GET_DEPOSIT_PAYMENT_BY_ID_FAILED = 'GET_DEPOSIT_PAYMENT_BY_ID_FAILED';

export const EDIT_DEPOSIT_START = 'EDIT_DEPOSIT_START';
export const EDIT_DEPOSIT_SUCCESS = 'EDIT_DEPOSIT_SUCCESS';
export const EDIT_DEPOSIT_FAILED = 'EDIT_DEPOSIT_FAILED';

export const EDIT_DEPOSIT_PAYMENT_START = 'EDIT_DEPOSIT_PAYMENT_START';
export const EDIT_DEPOSIT_PAYMENT_SUCCESS = 'EDIT_DEPOSIT_PAYMENT_SUCCESS';
export const EDIT_DEPOSIT_PAYMENT_FAILED = 'EDIT_DEPOSIT_PAYMENT_FAILED';

export const getDepositListStart = () => ({
  type: GET_DEPOSIT_LIST_START,
});

export const getDepositListSuccess = (data) => ({
  type: GET_DEPOSIT_LIST_SUCCESS,
  data
});

export const getDepositListFailed = (error) => ({
  type: GET_DEPOSIT_LIST_FAILED,
  error
});

export const getDepositByIdStart = () => ({
  type: GET_DEPOSIT_BY_ID_START,
});

export const getDepositByIdSuccess = (data) => ({
  type: GET_DEPOSIT_BY_ID_SUCCESS,
  data
});

export const getDepositByIdFailed = (error) => ({
  type: GET_DEPOSIT_BY_ID_FAILED,
  error
});

export const getDepositPaymentByIdStart = () => ({
  type: GET_DEPOSIT_PAYMENT_BY_ID_START,
});

export const getDepositPaymentByIdSuccess = (data) => ({
  type: GET_DEPOSIT_PAYMENT_BY_ID_SUCCESS,
  data
});

export const getDepositPaymentByIdFailed = (error) => ({
  type: GET_DEPOSIT_PAYMENT_BY_ID_FAILED,
  error
});

export const editDepositStart = () => ({
  type: EDIT_DEPOSIT_START,
});

export const editDepositSuccess = (data) => ({
  type: EDIT_DEPOSIT_SUCCESS,
  data
});

export const editDepositFailed = (error) => ({
  type: EDIT_DEPOSIT_FAILED,
  error
});

export const editDepositPaymentByIdStart = () => ({
  type: EDIT_DEPOSIT_PAYMENT_START,
});

export const editDepositPaymentByIdSuccess = (data) => ({
  type: EDIT_DEPOSIT_PAYMENT_SUCCESS,
  data
});

export const editDepositPaymentByIdFailed = (error) => ({
  type: EDIT_DEPOSIT_PAYMENT_FAILED,
  error
});

